module.exports = __webpack_public_path__ + "img/germany-digestive-diseases-male.f2a9ce84.png";